<span *ngIf="name">{{ name }}</span>
